<template>
<div>
    <el-dialog
        :title="$t('lang.Modify')"
        :visible="visible"
        :width="width"
        @close="close"
    >
        <div class="form-container">
            <el-form>
                <el-form-item :label="$t('lang.VerifyCode')">
                    <el-input v-model="form.verifyCode" :placeholder="$t('lang.textVerifyCode')">
                        <template slot="append">
                            <el-button type="primary"  @click="sendCode(userInfo)">{{ $t('lang.sendVerifyCode') }}</el-button>
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('lang.NewEmail')">
                    <el-input  v-model="form.email" type="text" :placeholder="$t('lang.textEmailAddress')" />
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">{{ $t("lang.ReturnPage") }}</el-button>
            <el-button type="primary" @click="submitEvent">{{ $t("lang.submit") }}</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
export default {
    name:'emailModifyDialg',
    data(){
        return {
            url:{
                sendCode:BASE_GLOB_API+'/register/verifyCode/send',
                edit:BASE_GLOB_API+'/user/edit',
                info:BASE_GLOB_API+'/user/info',
            },
            visible:false,
            width:'480px',
            btnIsDisabled:false,
            btnLoading:false,
            lang: "",
            userInfo:{},
            form:{
                verifyCode:'',
                email:'',
            },
        }
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
    },
    methods:{
        submitEvent(){
         
            if(!this.form.verifyCode){
                this.$message.error(this.$t("lang.textVerifyCode"));
                return;
            }
            if(!this.form.email){
                this.$message.error(this.$t("lang.textEmailAddress"));
                return;
            }
            let params = {
                account:this.userInfo.account,
                email:this.form.email,
                verifyCode:this.form.verifyCode,
            }
            axiosPost(this.url.edit, params).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.close()
                    this.$emit("ok");
                    this.form.email ='';
                    this.form.verifyCode ='';
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        sendCode(data){
            
            let params = {
                email:data.email
            }
            axiosGet(this.url.sendCode, params,60000).then(res=>{
                this.twoFALoading = false;
                if(res.success){
                    this.$message.success(res.message);
                }else{
                    this.$message.error(res.message);
                }
                
            })
        },
        open(userInfo){
            console.log("userInfo",userInfo)
            this.userInfo =userInfo
            this.visible = true;
        },
        close(){
            this.visible = false;
        },
       
    }
}
</script>
<style lang="less" scoped>

</style>